/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { ErrorState, RootState } from '../types';

export const getErrorFromState = (state: RootState): ErrorState => {
  return state.error;
};
